// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Zc9YjWCHQYsj4K {
  display: flex;
  align-items: center;
  margin-top: var(--ds-space-050, 4px);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin-bottom: 28px;
}
.oQhe5VP3qNgpc3 {
  display: inline-block;
  margin-right: var(--ds-space-100, 8px);
}
.PSsPavVGi7HMTT {
  margin-top: var(--ds-space-250, 20px);
}
.RirAkYf9rfCtL0 {
  color: var(--ds-text-subtle, #44546f);
}
.wrCgJxyz86gQod {
  margin: var(--ds-space-0, 0);
  color: var(--ds-text, #172b4d);
  font-size: medium;
}
.u0SyHzu50I4zDL {
  margin: var(--ds-space-0, 0);
  color: var(--ds-text-subtle, #44546f);
}
@media screen and (max-width: 450px) {
  .Zc9YjWCHQYsj4K {
    display: block;
  }
  .RirAkYf9rfCtL0,
  .wrCgJxyz86gQod,
  .u0SyHzu50I4zDL {
    text-align: center;
  }
  .oQhe5VP3qNgpc3 {
    display: flex;
    justify-content: center;
  }
}
`, ""]);
// Exports
export var memberInfoContainer = `Zc9YjWCHQYsj4K`;
export var memberAvatar = `oQhe5VP3qNgpc3`;
export var innerContainer = `PSsPavVGi7HMTT`;
export var description = `RirAkYf9rfCtL0`;
export var fullName = `wrCgJxyz86gQod`;
export var email = `u0SyHzu50I4zDL`;
export default ___CSS_LOADER_EXPORT___;
